/*
 * Automaically generated by SVGR from assets/icons/*.svg.
 * Do not edit this file or add other components to this directory.
 */
import type { SVGProps } from 'react'
export function ChevronRightIcon(props: SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={25}
      height={24}
      fill='none'
      {...props}
    >
      <mask
        id='chevron-right_svg__a'
        width={25}
        height={24}
        x={0}
        y={0}
        maskUnits='userSpaceOnUse'
        style={{
          maskType: 'alpha',
        }}
      >
        <path fill='#D9D9D9' d='M.333 0h24v24h-24z' />
      </mask>
      <g mask='url(#chevron-right_svg__a)'>
        <path
          fill='#9DA1A9'
          d='m9.733 18-1.4-1.4 4.6-4.6-4.6-4.6 1.4-1.4 6 6-6 6Z'
        />
      </g>
    </svg>
  )
}
